import { cartographicToCartesian } from 'ayvri-std/lib/ellipsoid';
import { Vec3 } from 'ayvri-std/lib/vector';
import { convertToRadian, defaultValue } from './helpers/index';
const scratchVec3 = new Vec3();
const kScale = window.devicePixelRatio;
export default class Labels {
    constructor() {
        this.elements = [];
    }
    onSceneLoad(scene, globes, hud) {
        const labels = defaultValue(scene.rawJson.labels, []);
        this.elements = labels.map(desc => {
            const element = hud.createElement(desc.name);
            const pos = cartographicToCartesian(convertToRadian(desc.latitude), convertToRadian(desc.longitude), desc.altitude, scratchVec3);
            element.setCanvas(getTextCanvas(desc.name));
            element.setScale(1.0 / kScale);
            element.setWorldPos(pos);
            element.setShow(true);
            element.setVisibilityTesting(true);
            return element;
        });
    }
    update(globe) {
    }
}
function getTextCanvas(text) {
    const outlineWidthPx = 2;
    // Options vars
    const lines = Array.isArray(text) ? text : text.split('\n');
    const font = '14px Arial, sans-serif';
    // Create a canvas that will cache the text
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    // Size the canvas to fit the text
    ctx.font = font;
    const lineHeight = parseInt(font, 10) * 1.15 + outlineWidthPx;
    const width = Math.max.apply(null, lines.map(t => ctx.measureText(t).width)) + outlineWidthPx * 2;
    const height = lines.length * lineHeight;
    canvas.width = width * kScale;
    canvas.height = height * kScale;
    ctx.scale(kScale, kScale);
    // Font styling
    ctx.font = font;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#E3E3E3';
    ctx.strokeStyle = 'black';
    ctx.lineWidth = outlineWidthPx;
    ctx.lineJoin = 'bevel';
    for (let i = 0; i < lines.length; i++) {
        ctx.strokeText(lines[i], width * 0.5, lineHeight * (i + 0.5));
        ctx.fillText(lines[i], width * 0.5, lineHeight * (i + 0.5));
    }
    return canvas;
}
